import { render, staticRenderFns } from "./VFormItemRangeDateTime.vue?vue&type=template&id=0b784a34&"
import script from "./VFormItemRangeDateTime.vue?vue&type=script&lang=js&"
export * from "./VFormItemRangeDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports